import BlujayBcaTransactionIndex from "@/components/blujay_bca/transactions/BlujayBcaTransactionIndex.vue";
import BlujayBcaTransactionDetail from "@/components/blujay_bca/transactions/BlujayBcaTransactionDetail.vue";

let BlujayBcaTransactionRoute= [
    {
        path: '',
        meta: {
          title: "List Bank Transaction",
        },
        name: "BlujayBcaTransactionIndex",
        component: BlujayBcaTransactionIndex
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Bank Transaction",
        },
        name: "BlujayBcaTransactionDetail",
        component: BlujayBcaTransactionDetail
    },
     
     
    
]

export default BlujayBcaTransactionRoute
  